import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SupplementaryAccountsService } from 'src/app/core/services/supplementary-accounts.service';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';

@Component({
  selector: 'app-user-confirmation-general',
  templateUrl: './user-confirmation-general.component.html',
  styleUrls: ['./user-confirmation-general.component.scss']
})
export class UserConfirmationGeneralComponent implements OnInit {

  @Input() suppuserId; @Input() suppuser;
  // suppuser;
  imagePath = environment.url;
  constructor(
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private suppService: SupplementaryAccountsService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    // this.loadCurrentSA();
  }

  closeDialog() {
    this.activeModal.close();
  }
  ok(action) {
    this.spinner.show();
    this.suppService.saMakePrimary(this.suppuser.id, action).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        if (response.message) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.message;
        }
        this.activeModal.close(true);
      } else if (response.errors) {
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = response.errors;
      }
    }, (error) => {
      this.spinner.hide();
    });

  }
  loadCurrentSA() {
    this.spinner.show();
    this.suppService.loadSupplementaryAccountNew(this.suppuserId).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success && response.data.supplementary_user) {
          this.suppuser = response.data.supplementary_user;
          if (this.suppuser.avatar) {
            this.suppuser.avatar = this.imagePath + this.suppuser.avatar;
          }
          else {
            this.suppuser.avatar = null;
          }
        }
        // this.currentSAUser = respo
      }, (error: any) => {
        this.spinner.hide();
        // console.log(error);
      }
    )
  }


}
